export default {"src":"https://cdn.jetlend.ru/_next/static/media/icon--404.670ff865.svg","height":329,"width":370,"blurWidth":0,"blurHeight":0};